import React, {useEffect, useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import VoucherPanel from "../ViewVoucher/VoucherPanel";
import {EntityTypes, UserTypes} from "../../../common/Constants";
import { CircularProgress, Drawer, Fab, Typography } from "@mui/material";
import CreateOrUpdateVoucher from "../CreateVoucher";
import { EmptySearchOption, useSearch } from "../../../hooks/useSearch";
import { useAuth } from "../../../hooks/useAuth";

import {endpoints, useApi, useDebouncePost} from "../../../hooks/use-api";
import {Add} from "@mui/icons-material";
import CardGrid from "../../Cards";
import { useNavigate } from "react-router-dom";
import Routes from "../../../common/Routes";


import cx from 'classnames'
import { AppBar, Button } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import Badge from '@mui/material/Badge';
import { all } from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const EmptyVoucher = {
  id: 0,
  voucher_detail: {
    hasRecentPrescription: false,
    eye_exam_date: "",
    prescriptionHasPdMeasurement: false,
  },
  applicant: { type: EntityTypes.applicant },
};

// const mergeVoucherAction = (vouchers, id, action) => {

//     let otherVouchers = vouchers.filter(v => v.id !== id)
//     let voucher = { ...vouchers.find(v => v.id === id) }

//     voucher.overrides = voucher.overrides || {}
//     voucher.overrides.actions = [ action, ...voucher.actions ]

//     return [ voucher, ...otherVouchers ]
// }
const SearchVoucherInner = ({ vouchersAsync, reload }) => {
  const classes = useStyles();
  const { userType } = useSearch();

  const [currentVoucher, setCurrentVoucher] = useState(EmptyVoucher);

  const [showVoucher, setShowVoucher] = useState(false);
  //?? const [voucherId, setVoucherId] = useState(false)
  const [enableEdit, setEnableEdit] = useState(false);

  const cardItemFn =
    userType === UserTypes.neweyes
      ? (voucher) => ({
          title: `${voucher.id}`,
          t1: voucher.name,
          d1: voucher.datetime,
          t2: voucher.applicant_name,
          t4: voucher.user_name,
          status: voucher.status,
          note: voucher.note,
        })
      : (voucher) => ({
          title: `Voucher # ${voucher.id}`,
          t1: voucher.applicant_name,
          d1: voucher.datetime,
          t2: voucher.user_name,
          status: voucher.status,
          note: voucher.note,
        });

  if (!vouchersAsync) {
    return <CircularProgress />;
  }

  return (
    <>
      <Fab
        aria-label="Create a new voucher application"
        color="primary"
        variant="extended"
        style={{ position: "fixed", top: 80, right: 48, zIndex: 1150 }}
        onClick={() => {
          setCurrentVoucher(EmptyVoucher);
          setEnableEdit(true);
          setShowVoucher(true);
        }}
      >
        <Add className={classes.extendedIcon} /> New Application
      </Fab>      
      {vouchersAsync.data && (
        <>
          {/* <div style={{ padding: '0px 12px', marginTop: 70 + 100 + 36 }}> */}
          
            <CardGrid
              itemsAsync={vouchersAsync}
              itemsFn={(data) => data}
              itemfn={cardItemFn}
              itemTypeFn={() => EntityTypes.voucher}
              onSelect={(voucher) => {
                setEnableEdit(false);
                setShowVoucher(true);
                setCurrentVoucher(voucher);
              }}
            />
          
          <Drawer
            anchor="right"
            open={showVoucher}
            onClose={() => {
              if (!enableEdit) setShowVoucher(false);
            }}
            classes={{ paper: "wide-drawer" }}
          >
            {enableEdit ? (
              <CreateOrUpdateVoucher
                individualApplication={false}
                voucher={currentVoucher}
                onClose={() => {
                  setEnableEdit(false);
                  setCurrentVoucher(EmptyVoucher);
                  setShowVoucher(false);
                }}
                onExit={(result) => {
                  if (result) {
                    // setCurrentVoucher(result) //?? did it for reload
                    setEnableEdit(false);
                    setShowVoucher(false);
                    reload(true);
                  } else {
                    setShowVoucher(false);
                  }
                }}
              />
            ) : (
              <VoucherPanel
                voucher={currentVoucher}
                userType={userType}
                onEdit={() => setEnableEdit(true)}
                onClose={() => {
                  setEnableEdit(false);
                  setShowVoucher(false);
                }}
                onAction={(id, action) => {
                  setShowVoucher(false);
                  reload();
                  //?? setVouchers(mergeVoucherAction(vouchers, id, { ...action, datetime: new Date() })) //?? COME BACK
                }}
              />
            )}
          </Drawer>
        </>
      )}
    </>
  );
};

const SearchVoucher = ({
  reload: reloadParent,
  agencyId = 0,
  useSearchOption = true,
}) => {
  const { searchOption, setSearchOption } = useSearch();
  const { user } = useAuth();
  const [option, setOption] = useState(user.userType !== UserTypes.neweyes ? 'all' : 'approved')
  const [param, setParam] = useState(EmptySearchOption);

  useEffect(() => {
    console.log(searchOption)
    setParam(useSearchOption && searchOption.searchText !== "" ? { ...searchOption, voucherStatus: "all" } : { voucherStatus: option })
  }, [useSearchOption, searchOption, option])

  useEffect(() => {
    console.log(param)
  }, [param])

  const { returnAsync: vouchersAsync } = useDebouncePost(
    {
      url: endpoints.entity.voucher.search(agencyId),
      method: "post",
    },
    param,
    (param) => param
  );

  // Force reload the grid after any update
  const reload = () => {
    setSearchOption({ ...searchOption });
    if (reloadParent) reloadParent();
  };

  return <>
    {user.userType === UserTypes.neweyes &&
      <AppBar position="static" color="inherit" elevation={0}>
        <div className="voucherFilter">
          <Grid2 container justifyContent='center'>
            <ul className={cx("result-filters")}>
              <InboxOption optionText="All" selected={option === "all"} onChange={() => setOption("all")} />
              <InboxOption optionText="Approved" selected={option === "approved"} onChange={() => setOption("approved")} />
              <InboxOption optionText="Rejected" selected={option === "rejected"} onChange={() => setOption("rejected")} />
              <InboxOption optionText="Redeemed" selected={option === "redeemed"} onChange={() => setOption("redeemed")} />
              <InboxOption optionText="Cancelled" selected={option === "cancelled"} onChange={() => setOption("cancelled")} />
              <InboxOption optionText="Paid" selected={option === "paid"} onChange={() => setOption("paid")} />
            </ul>
          </Grid2>
        </div>
      </AppBar>}
    {useSearchOption && searchOption.searchText !== "" && <Grid2 sx={{ ml: 8, mt: 2 }}>
      <Typography variant="caption">Search result for:</Typography>&nbsp;{searchOption.searchText}
    </Grid2>}
    <SearchVoucherInner vouchersAsync={vouchersAsync} reload={reload} />
  </>;
};

const InboxOption = ({ optionText, count, selected, onChange }) => (
  <li className="column is-narrow voucher-status-sel clickable">
    <Badge
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      badgeContent={count}
      color="primary"
    >
      <Button variant='text' className={cx({ selected: selected })}>
        <span onClick={onChange}>{optionText}</span>
      </Button>
    </Badge>

  </li>
)

const SearchVoucherPending = ({ reload: reloadParent, url = endpoints.entity.voucher.pending_approval(), agencyId = 0 }) => {
  const [{ data, loading, error }, refetch] = useApi(
    url,
    { useCache: false }
  );
  const navigate = useNavigate();

  const reload = (newVoucher) => {
    // If it is a newVoucher then we should be on the vouchers tab to show the newly added voucher
    if (newVoucher) {
      navigate(Routes.vouchers.route);
    } else {
      refetch();
      if (reloadParent) reloadParent();
    }
  };

  return (
    <>
      {/* <AddressAutocomplete /> */}
      <SearchVoucherInner
        vouchersAsync={{ data, loading, error }}
        reload={reload}
      />
      
    </>
  );
};



export { SearchVoucherPending, SearchVoucher };
